module.exports = __webpack_public_path__ + "assets/img/clinical-training-banner.0682c1f2.png";